module.exports = __webpack_public_path__ + "img/taoambro3.430bb2f9.jpeg";